import { useElementWidth } from '@gorila-shared-ui/components';
import { Block } from 'baseui/block';
import { Card } from 'baseui/card';
import { StyledDivider } from 'baseui/divider';
import { CSSProperties, memo } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { currentStateState } from '../../storage/client';
import CurrentStateCardBody from './CurrentStateCardBody';
import CurrentStateCardFooter from './CurrentStateCardFooter';
import CurrentStateCardHeader from './CurrentStateCardHeader';

function CurrentStateCard({ data, index, style }: Readonly<ListChildComponentProps<string[]>>) {
  const ident = data[index];
  const { theme } = useStyles();
  const currentState = useRecoilValue(currentStateState(ident));
  const { refCallback: contentRef, elementWidth: contentWidth } = useElementWidth();

  const responsive = !(contentWidth > 550);

  if (!currentState) {
    return null;
  }

  return (
    <Block
      style={style as CSSProperties}
      ref={contentRef}
    >
      <Card
        overrides={{
          Root: {
            style: {
              height: 'calc(100% - 16px)',
              boxSizing: 'border-box',
              borderLeftWidth: '1px',
              borderRightWidth: '1px',
              borderTopWidth: '1px',
              borderBottomWidth: '1px',
              backgroundColor: currentState.asset.inJourney ? theme.colors.backgroundLightAccent : undefined,
            },
          },
          Contents: {
            style: {
              marginTop: 0,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
            },
          },
          Body: {
            style: {
              marginBottom: 0,
            },
          },
        }}
      >
        <CurrentStateCardHeader currentState={currentState} />
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0 }}
        />
        <CurrentStateCardBody
          currentState={currentState}
          responsive={responsive}
        />
        <StyledDivider
          $size="cell"
          style={{ marginTop: 0, marginBottom: 0 }}
        />
        <CurrentStateCardFooter currentState={currentState} />
      </Card>
    </Block>
  );
}

export default memo(CurrentStateCard);
